import { Component, DestroyRef, inject, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Company } from '../../@classes/company';
import { Constants } from '../../@classes/constants';
import { FilterListing } from '../../@classes/filterListing';
import { Menu } from '../../@classes/menu';
import { Tab } from '../../@classes/tab';
import { MenuController, PopoverController, IonIcon, IonLabel, IonItem, IonList, IonContent, IonPopover } from '@ionic/angular/standalone';
import { LangRoutingService } from '../../@services/lang-routing';
import { PropertyUrlService } from '../../@services/property-url.service';
import { NgClass } from '@angular/common';
import { IconService } from '../../@services/icon-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

type TabsArray = Array<Tab>;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    NgClass, IonIcon, TranslatePipe, IonLabel, IonItem, IonList, IonContent, IonPopover,
    RouterLink
  ]
})
export class HeaderComponent implements OnInit {

  private iconService      = inject(IconService);
  private destroyRef = inject(DestroyRef);
  
  company_slug: string = 'ljhrealty';
  currentLang: string = 'id';
  filter: FilterListing | null = null;
  query: string = "";
  company: Company | null = null;
  company_text: string = "";

  find_properties: TabsArray = Menu.find_properties;
  businesses: TabsArray = Menu.businesses;
  info_property: TabsArray = Menu.info_property;
  about_uses: TabsArray = Menu.about_uses;
  base_url: string = Constants.BASE_URL;

  private langRouting = inject(LangRoutingService);
  private propertyUrlService = inject(PropertyUrlService);

  constructor(
    private route: ActivatedRoute,
    public menuController: MenuController,
    private popoverController: PopoverController,
    private router: Router,
    private cookieService: CookieService,
    public translate: TranslateService,
    private zone: NgZone,
  ) {
    if (this.cookieService.get('company') !== '') {
      this.company = JSON.parse(this.cookieService.get('company'));
    }
    if (this.company !== null) {
      this.company_text = this.company.name.replace("LJH Realty", "");
    }
  }

  ngOnInit() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.currentLang = params.get('lang') || 'id';
      });
  }

  ionViewWillEnter() {
    this.company_slug = this.cookieService.get('company_slug') || this.company_slug;
  }

  return() {
    this.cookieService.set('company_slug', 'ljhrealty');
    this.company_slug = 'ljhrealty';
    this.cookieService.set('company', '');
    this.langRouting.navigateByUrl('/home');
  }

  get isAnySubheader(): boolean {
    let subheader: boolean = false;
    let temp: ActivatedRoute = this.route;

    while (true) {
      if (temp.firstChild) {
        temp = temp.firstChild;
      } else {
        if ('subheader' in temp.snapshot.data) {
          subheader = temp.snapshot.data['subheader'];
        }
        break;
      }
    }
    return subheader;
  }

  activeUrl() {
    if (['/about', '/offices', '/testimony'].includes(this.router.url)) {
      return true;
    } else {
      return false;
    }
  }

  home() {
    console.log(this.cookieService.get('company_slug'));
    if (this.cookieService.get('company_slug') != 'ljhrealty' && this.cookieService.get('company_slug') != '') {
      this.company_slug = this.cookieService.get('company_slug');
      this.langRouting.navigateByUrl('/office/' + this.company_slug);
    } else {
      this.company_slug = 'ljhrealty';
      this.langRouting.navigateByUrl('/home');
    }
  }

  get homeLink(): string {
    const companySlug = this.cookieService.get('company_slug');
    const path = companySlug && companySlug !== 'ljhrealty'
      ? `/office/${companySlug}`
      : '/home';

    return this.localizedUrl(path);
  }

  navigate(url: string) {
    this.langRouting.navigateByUrl(url);
  }

  async openMenu() {
    await this.menuController.enable(true, 'rebornMenu');
    await this.menuController.open('rebornMenu');
  }

  async toggleMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    await this.menuController.toggle('rebornMenu');
  }

  async onMenuClick(event: Event) {
    await this.menuController.toggle('rebornMenu');
  }

  async switchEn(event: Event) {
    event.stopPropagation();
    await this.switchLang('en');
  }

  async switchId(event: Event) {
    event.stopPropagation();
    await this.switchLang('id');
  }

  private async switchLang(lang: string) {
    await this.popoverController.dismiss(undefined, undefined, 'lang');
    await this.langRouting.switchLang(lang);
  }

  get find_propertiesTriggerId(): string {
    return `find_properties-${this.currentLang}`;
  }

  get businessTriggerId(): string {
    return `business-${this.currentLang}`;
  }

  get infoPropertyTriggerId(): string {
    return `whats-new-${this.currentLang}`;
  }

  get aboutUsTriggerId(): string {
    return `about-us-${this.currentLang}`;
  }

  get languageTriggerId(): string {
    return `language-${this.currentLang}`;
  }

  localizedUrl(url: string): string {
    return this.langRouting.buildUrl([
      url.startsWith('/') ? url.substring(1) : url
    ]);
  }

  inputListingChange(event: any) {
    this.query = event.detail.value;
  }
}
